import script from "./AfterSalesRefunds.vue?vue&type=script&lang=ts&setup=true"
export * from "./AfterSalesRefunds.vue?vue&type=script&lang=ts&setup=true"

import "./AfterSalesRefunds.vue?vue&type=style&index=0&id=38fca963&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38fca963"]])

export default __exports__